var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.ContactsBanner),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "elevation-1 rounded-sm d-flex flex-wrap pa-6 mb-4" },
        _vm._l(_setup.context.company_contacts, function (contact, i) {
          return _c(_setup.ContactsItemBlock, {
            key: i,
            staticClass: "w-50 mb-4",
            attrs: { contact: contact },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "elevation-1 rounded-sm pa-6" },
        [
          _vm._l(
            _setup.context.company_ceo_contacts,
            function (ceo_contact, i) {
              return _c(
                "div",
                { key: i },
                [
                  _c(_setup.ContactsSeoProfile, {
                    attrs: { profile: ceo_contact },
                  }),
                  _vm._v(" "),
                  _c(_setup.ContactsAddresses, {
                    attrs: { addresses: ceo_contact.addresses.all },
                  }),
                ],
                1
              )
            }
          ),
          _vm._v(" "),
          _c(_setup.ContactsMap, {
            attrs: { "map-data": _setup.context.company_ceo_contacts[0] },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }